import { render, staticRenderFns } from "./Form46.vue?vue&type=template&id=22b7ccc8&scoped=true"
import script from "./Form46.vue?vue&type=script&lang=ts"
export * from "./Form46.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=22b7ccc8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b7ccc8",
  null
  
)

export default component.exports